import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PersonIcon from '@mui/icons-material/Person';
import PreviewIcon from '@mui/icons-material/Preview';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import ReplayIcon from '@mui/icons-material/Replay';
import { Badge, Box } from '@mui/material';
import { RolesTypes } from '../../../config/roles';
import { ActionButtons } from '../../../constants/actionButtons';
import { checkPermissions } from '../../../helpers/checkPermissionHelper';
import ButtonWrapper from '../../formUtilities/useButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

export const TableActionColumn = ({
	width = 130,
	visibleActionsList = [ActionButtons.Deatil],
	onDeatil = (e, row) => { },
	onEdit = (e, row) => { },
	onShowTransactions = (e, row) => { },
	onDelete = (e, row) => { },
	onTransactionDecline = (e, row) => { },
	onTransactionApprove = (e, row) => { },
	onCancelTransaction = (e, row) => { },
	onCancelDeposit = (e, row) => { },
	onReconcileHyperPay = (e, row) => { },
	onRead = (e, row) => { },
	onSend = (e, row) => { },
	onContractDownload = (e, row) => { },
	onSubjectDownload = (e, row) => { },
	onAECBErrorPopup = (e, row) => { },
	onPreview = (e, row) => { },
	onActivate = (e, row) => { },
	onDeactivate = (e, row) => { },
	onAdd = (e, row) => { },
	onConfirm = (e, row) => { },
	onPressNote = (e, row) => { },
	onResendVerificationEmail = (e, row) => { },

}) => {
	const actionColumn = {
		accessorKey: 'action',
		size: width,
		maxSize: 150,
		header: 'Actions',
		enableHiding: false,
		enablePinning: true,
		enableEditing: false,
		muiTableHeadCellProps: {
			align: 'center',
		},
		Cell: ({ cell, row }) => {
			return (
				<Box className="flex flex-0 items-center justify-center space-x-2">
					{showButtons(ActionButtons.AECBErrorPopup) ? (
						<Box className="mx-2">
							<Badge
								componentsProps={{
									badge: { className: '!text-[9px] !top-1.5' },
								}}
								max={99}
								showZero={true}
								badgeContent={row?.original?.errors?.length || 0}
								color="error">
								<ButtonWrapper
									tooltip="AECB Report Errors"
									icon={<ErrorOutlineIcon color="error"></ErrorOutlineIcon>}
									iconButton={true}
									onClick={(e) =>
										onAECBErrorPopup && onAECBErrorPopup(e, row?.original)
									}></ButtonWrapper>
							</Badge>
						</Box>
					) : (
						''
					)}
					{showButtons(ActionButtons.Send) ? (
						<ButtonWrapper
							tooltip="Send"
							icon={<SendToMobileIcon color="secondary"></SendToMobileIcon>}
							iconButton={true}
							onClick={(e) =>
								onSend && onSend(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.Edit) ? (
						<ButtonWrapper
							icon={<EditIcon></EditIcon>}
							iconButton={true}
							onClick={(e) =>
								onEdit && onEdit(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.AddMoney) ? (
						<ButtonWrapper
							icon={<AddOutlinedIcon></AddOutlinedIcon>}
							iconButton={true}
							onClick={(e) =>
								onAdd && onAdd(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.Confirm) ? (
						<ButtonWrapper
							icon={<DoneIcon></DoneIcon>}
							iconButton={true}
							onClick={(e) =>
								onConfirm && onConfirm(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.Delete) ? (
						<ButtonWrapper
							icon={<DeleteOutlineIcon color="error"></DeleteOutlineIcon>}
							iconButton={true}
							onClick={(e) =>
								onDelete && onDelete(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.Deatil) ? (
						<ButtonWrapper
							icon={<VisibilityIcon></VisibilityIcon>}
							iconButton={true}
							onClick={(e) =>
								onDeatil && onDeatil(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}

					{showButtons(ActionButtons.BlogPreview) ? (
						<ButtonWrapper
							icon={<PreviewIcon className="text-[#7850f2]"></PreviewIcon>}
							iconButton={true}
							onClick={(e) =>
								onPreview &&
								onPreview(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}

					{showButtons(ActionButtons.Transactions) ? (
						<ButtonWrapper
							icon={<ReceiptLongIcon color="secondary"></ReceiptLongIcon>}
							iconButton={true}
							onClick={(e) =>
								onShowTransactions && onShowTransactions(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}

					{showButtons(ActionButtons.ReportContractDonwload) ? (
						<ButtonWrapper
							icon={<DescriptionIcon color="secondary"></DescriptionIcon>}
							iconButton={true}
							onClick={(e) =>
								onContractDownload && onContractDownload(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}

					{showButtons(ActionButtons.ReportSubjectDownload) ? (
						<ButtonWrapper
							icon={<PersonIcon color="primary"></PersonIcon>}
							iconButton={true}
							onClick={(e) =>
								onSubjectDownload && onSubjectDownload(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}

					{!row?.original?.isRead ? (
						<>
							{showButtons(ActionButtons.Read) ? (
								<ButtonWrapper
									icon={
										<ChromeReaderModeIcon color="primary"></ChromeReaderModeIcon>
									}
									iconButton={true}
									onClick={(e) =>
										onRead && onRead(e, row?.original)
									}></ButtonWrapper>
							) : (
								''
							)}
						</>
					) : null}
					{(showButtons(ActionButtons.PromoCodeActivate) || showButtons(ActionButtons.PromoCodeDeactivate)) ? <>
						{!row?.original?.isActive ? <>
							<ButtonWrapper
								tooltip={'Activate'}
								icon={<DoneIcon></DoneIcon>}
								iconButton={true}
								onClick={(e) =>
									onActivate &&
									onActivate(e, row?.original)
								}></ButtonWrapper>
						</> : <>
							<ButtonWrapper
								tooltip={'Deactivate'}
								icon={<CloseIcon className="text-red-500"></CloseIcon>}
								iconButton={true}
								onClick={(e) =>
									onDeactivate &&
									onDeactivate(e, row?.original)
								}></ButtonWrapper>
						</>}
					</> : null}
					{row?.original?.isConfirmed == null && row?.original?.isVerified && !row?.original?.hyperPayStatus && showButtons(ActionButtons.TransactionApprove) ? (
						<ButtonWrapper
							tooltip={'Approve'}
							icon={<DoneIcon></DoneIcon>}
							iconButton={true}
							onClick={(e) =>
								onTransactionApprove &&
								onTransactionApprove(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{row?.original?.isConfirmed == null && !row?.original?.hyperPayStatus && showButtons(ActionButtons.TransactionDecline) ? (
						<ButtonWrapper
							tooltip={'Decline'}
							icon={<CloseIcon className="text-red-500"></CloseIcon>}
							iconButton={true}
							onClick={(e) =>
								onTransactionDecline &&
								onTransactionDecline(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.ReconcileHyperPayTransaction) && checkPermissions(RolesTypes.ReconcileHyperPayTransaction) && row?.original?.isHyperPayReconcilable ? (
						<ButtonWrapper
							tooltip={'Retry HyperPay Payment'}
							icon={<ReplayIcon></ReplayIcon>}
							iconButton={true}
							onClick={(e) =>
								onReconcileHyperPay &&
								onReconcileHyperPay(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.LoanTransactionCancel) && checkPermissions(RolesTypes.CancelTransaction) && row?.original?.isCancellable && !row?.original?.isDeposit ? (
						<ButtonWrapper
							tooltip={'Cancel Investment'}
							icon={<CancelOutlinedIcon></CancelOutlinedIcon>}
							iconButton={true}
							onClick={(e) =>
								onCancelTransaction &&
								onCancelTransaction(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.DepositTransactionCancel) && checkPermissions(RolesTypes.CancelDeposit) && row?.original?.isCancellable && row?.original?.isDeposit ? (
                    <ButtonWrapper
                        tooltip={'Cancel Deposit'}
                        icon={<CancelOutlinedIcon className="text-red-500"></CancelOutlinedIcon>}
                        iconButton={true}
                        onClick={(e) =>
                            onCancelDeposit &&
                            onCancelDeposit(e, row?.original)
                        }></ButtonWrapper>
                ) : (
                    ''
                )}
					{showButtons(ActionButtons.InvestorNote) ? (
						<ButtonWrapper
							icon={<EditNoteOutlinedIcon></EditNoteOutlinedIcon>}
							iconButton={true}
							onClick={(e) =>
								onPressNote &&
								onPressNote(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
					{showButtons(ActionButtons.ResendVerificationEmail) && row?.original?.emailConfirmed === false ? (
						<ButtonWrapper
							tooltip="Resend Verification Email"
							icon={<MarkEmailUnreadIcon color="secondary"></MarkEmailUnreadIcon>}
							iconButton={true}
							onClick={(e) =>
								onResendVerificationEmail &&
								onResendVerificationEmail(e, row?.original)
							}></ButtonWrapper>
					) : (
						''
					)}
				</Box>
			);
		},
	};

	const showButtons = (type) => {
		return !!visibleActionsList.find((btnType) => btnType === type);
	};

	return actionColumn;
};
